import { render, staticRenderFns } from "./UserDashboardFacilitiesDonor.vue?vue&type=template&id=a3c4b470&scoped=true&"
import script from "./UserDashboardFacilitiesDonor.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilitiesDonor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c4b470",
  null
  
)

export default component.exports